package one.healthium.ui.compose.theme.styles

import androidx.compose.runtime.Immutable
import androidx.compose.ui.graphics.Color
import one.healthium.ui.compose.theme.gray_2
import one.healthium.ui.compose.theme.orange_2

data class DailyTaskStyle(
    private val progressBarColor: Color? = null,
    private val progressBarTrackColor: Color? = null,
    val itemStyle: DailyTaskItemStyle = DailyTaskItemStyle.V1,
) {
    val progressBarColorOrDefault: Color
        get() = progressBarColor ?: orange_2

    val progressBarTrackColorOrDefault: Color
        get() = progressBarTrackColor ?: gray_2
}

@Immutable
sealed interface DailyTaskItemStyle {
    data object V1 : DailyTaskItemStyle // colored card
    data class V2(
        val containerColor: Color? = null,
        val contentColor: Color? = null,
        val iconTint: Color? = null,
    ) : DailyTaskItemStyle // surface card
}